import type { MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import type { PopoverPosition } from '@mui/material/Popover';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

type Props = {
  /** Where the user right-clicked; null while the menu is closed. */
  position: PopoverPosition | null;
  onClose: () => void;
  onCopy: () => void;
};

// A click on the menu or around it must not reach the pages list, which closes the thumbnails drawer.
const keepClickInMenu = (event: MouseEvent) => event.stopPropagation();

const WordContextMenu = ({ position, onClose, onCopy }: Props) => (
  <Menu
    open={position !== null}
    onClose={onClose}
    anchorReference="anchorPosition"
    anchorPosition={position ?? undefined}
    // Opened by the mouse: the list takes the focus, so no item looks keyboard-selected; arrows still reach Copy.
    disableAutoFocusItem
    onClick={keepClickInMenu}
    onContextMenu={(event) => {
      // A right click around the open menu closes it instead of opening the browser's own menu.
      event.preventDefault();
      onClose();
    }}
  >
    <MenuItem onClick={onCopy}>
      <ListItemIcon>
        <ContentCopyIcon color="primary" />
      </ListItemIcon>
      <ListItemText slotProps={{ primary: { variant: 'body2' } }}>
        <FormattedMessage id="document.polygon.contextMenu.copy" defaultMessage="Copy" />
      </ListItemText>
    </MenuItem>
  </Menu>
);

export default WordContextMenu;
